/*
 * @Author: your name
 * @Date: 2020-12-10 11:52:33
 * @LastEditTime: 2023-08-03 18:51:38
 * @LastEditors: pangting
 * @Description: In User Settings Edit
 * @FilePath: \CoreWeb\packages\ui\src\index.ts
 */
// 导出模块 
export * from './components/DataUI/DataUIType'
export * from './components/DataUI/DataGridApi'
export * from './components/EchartsGenerator/EchartsGeneratorApi'
export * from './components/PropertyGrid/PropertySchema'
export * from './components/schema/UISchema'

export * from './components/ReportUI/ReportType'
export * from './components/ReportUI/ReportApi'

import Root from './components/Root.vue'
import nvEleCalendar from './components/nv-eleCalendar.vue'
import CASignView from './components/CASign.vue'
import customModal from './components/Modal.vue'
import nvTag from './components/nv-tag.vue'
import nvLoading from './components/nv-loading.vue'
import nselect from './components/nSelect.vue'
import dicSelect from './components/dicSelect.vue'
import dicTypeSelect from './components/dicTypeSelect.vue'
import comRegion from './components/comRegion.vue'
import comInstitution from './components/comInstitution.vue'
import comRegion2 from './components/comRegion2.vue'
import jsonEdit from './components/JsonEdit.vue'
import TextJsonEdit from './components/TextJsonEdit.vue'
import toolBar from './components/ToolBar.vue'
import searchCom from './components/searchCom.vue'
import grid from './components/grid.vue'
import treeGrid from './components/tree-grid.vue'
import changeTheme from './components/change-theme.vue'
import imgBase64 from './components/imgBase64.vue'
import uploadFile from './components/uploadFile.vue'
import javaUploadFile from './components/javaUploadFile.vue'
import javaUploadFileList from './components/javaUploadFileList.vue'
import comForm from './components/comForm.vue'
import pageTitle from './components/pageTitle.vue'
import excelImport from './components/excel-import.vue'
import logPanel from './components/log-panel.vue'
import dynamicForm from './components/dynamic-form.vue'
import textEditor from './components/text-editor.vue'
import dateAreaSel from './components/dateAreaSel.vue'
import autocomplete from './components/autocomplete.vue'
import Highchart from './components/highchart.vue'
import echart from './components/echart.vue'
import comDetails from './components/comDetails.vue'
import dataGrid from "./components/DataUI/DataGrid.vue"
import changeSubsys from "./components/change-subsys.vue"
import vxeTreeGrid from "./components/vxeTreeGrid.vue"
import vxeGrid from "./components/vxeGrid.vue"
import transfer from "./components/transfer.vue"
import listview from "./components/listview.vue"
import ImageMark from './components/ImageMark.vue'
import PicturePreview from "./components/PicturePreview.vue"
// import echartsGenerator from "./components/EchartsGenerator/Index.vue";
// import echartsParse from "./components/EchartsGenerator/ParsePage.vue";
import FilterTable from './components/FilterTable.vue'
import leftSelect from './components/leftSelect.vue'
import propertyGrid from "./components/PropertyGrid/PropertyGrid.vue";
import boxBorderIcon from './components/box-border-icon.vue'
import notification from './components/notification.vue'
import flowSteps from './components/flow-steps.vue'
import treeView from './components/treeView.vue'
import CASignVerify from './components/CASignVerify.vue'
import HKCameraWall from './components/nv-HKCameraWall.vue'
import updatePwd from './components/updatePwd.vue'
import loginout from './components/loginout.vue'
import userAvatar from './components/userAvatar.vue'
import applySign from './components/applySign.vue'
/* 注意注意！！！请将新增的公共的组件导出于该行注释之前  */
import MainManageCom from "./components/MainManage.vue"
import LoginCom from "./components/Login.vue"
import toolsPanel from "./components/ToolsPanel.vue";
import ApprovalFlow from "./components/ApprovalFlow.vue"
import MonacoEditor from "./components/MonacoEditor.vue"
import box from "./components/nmis/components/box.vue";
import layout from "./components/nmis/components/layout.vue";
import nmis from "./components/nmis/nmis";
import list from "./components/nmis/components/list";
import filterTool from "./components/nmis/util/filterTool"
import dynamicPage from "./components/DynamicPage.vue";
import WechartQR from "./components/WechartQR.vue";
import ItemTitle from './components/item-title.vue'
import nvLayout from "./components/nvLayout.vue"
import nvLayoutCell from "./components/nvLayoutCell.vue"
import nvTimeLine from "./components/nvTimeLine.vue"
// import DrawFlow from "./components/DrawFlow";
import {workflow, workflowyh} from "./components/Workflow";
import addNode from "./components/Workflow/components/addNode.vue";
import nodeWrap from "./components/Workflow/components/nodeWrap.vue";
// NvUI 组件
import nvTemplate from "./components/NvUI/NvTemplate";
import nvRadio from "./components/NvUI/NvRadio.vue";
import nvCheckbox from "./components/NvUI/NvCheckbox.vue";
import nvSelect from "./components/NvUI/NvSelect.vue";
import nvList from "./components/NvUI/NvList.vue";
import nvListItem from "./components/NvUI/NvListItem.vue";
import nvSpace from "./components/NvUI/NvSpace.vue";
import nvNewLine from "./components/NvUI/NvNewLine.vue";

import report from "./components/ReportUI/Report.vue"
import HKCameraWallBack from './components/nv-HKCameraWallBack.vue'
import nvMap from "./components/nvMap.vue"

export {
    workflowyh,
    nvMap, // 地图
    HKCameraWall,//海康监视控件
    nvEleCalendar,// 日历控件
    ItemTitle,     //块级头部
    CASignView,       //CA签章公共组件
    Root,         // 登陆中转页
    customModal,  // 弹出窗组件
    nvTag,        // 标签组件（可用来标记筛选条件）
    nvLoading,    // 加载中
    nselect,      // 自定义下拉列表
    dicSelect,    // 字典下拉列表
    dicTypeSelect,  //字典类型
    comRegion,    // 行政区域选择组件1
    comInstitution,    // 选择组件
    comRegion2,   // 行政区域选择组件2（级联菜单形式）
    jsonEdit,     // JSON编辑器组件
    TextJsonEdit, //文本JSON编辑器组件
    toolBar,      // 工具栏组件
    searchCom,    // 高级搜索组件
    grid,         // 数据表格组件（老：建议不再使用请使用vxeGrid替换）
    treeGrid,     // 树形表格组件（老：建议不再使用请使用vxeTreeGrid替换）
    changeTheme,  // 换肤列表组件
    imgBase64,    // 图片上传导出base64
    uploadFile,   // 文件上传组件
    javaUploadFile,    //nplms项目用（java）
    javaUploadFileList,
    comForm,      // 表单组件
    pageTitle,    // 页面头部标题
    excelImport,  // excel上传
    logPanel,     // 日志面板
    dynamicForm,  // 动态Form，生成没有固定model的Form表单
    textEditor,   // 富文本编辑器
    dateAreaSel,  // 日期区域选择组件（APM中用到过）
    Highchart,    // highcharts图表
    echart,
    autocomplete, // 建议input
    comDetails,   // 表单详情页
    dataGrid,     // 数据Grid
    changeSubsys, //子系统切换
    vxeTreeGrid,  //vxe-table 树形表格组件
    vxeGrid,      //vxe-table 表格组件
    transfer,     //穿梭框
    listview,     //列表+列表选择组件
    // echartsGenerator, // EChart 生成器
    // echartsParse, // EChart 解析器
    FilterTable, //Table表格筛选
    leftSelect, //左侧选择
    propertyGrid, // 属性Grid
    boxBorderIcon,  //
    notification,    //消息提示组件
    flowSteps,        //流程步骤列表组件
    treeView,         //树形组件
    CASignVerify, // 签字验证
    updatePwd,    //修改密码
    loginout,     //退出登录
    userAvatar,   //用户名及头像
    applySign,    //申请签字组件
    /* 注意注意！！！请将新增的公共的组件导出于该行注释之前  */
    /* 组件导出顺序会影响互相使用 */
    LoginCom,     //登录组件（置于最后）
    MainManageCom,//大主页（置于最后），在主页导出前保证其他的子组件都已被导出，所以置于最后进行导出
    toolsPanel, // 工具面板
    ApprovalFlow, //审批流程组件
    MonacoEditor, // 编辑器
    nmis,
    box,
    layout,
    list,
    filterTool,
    dynamicPage,
    WechartQR,
    nvLayout,
    nvLayoutCell,
    nvTimeLine,   //横向时间轴
    // DrawFlow,
    addNode,
    nodeWrap,
    workflow,
    nvTemplate,
    nvRadio,
    nvCheckbox,
    nvSelect,
    nvList,
    nvListItem,
    nvSpace,
    nvNewLine,
    report,
    HKCameraWallBack,
    ImageMark,
    PicturePreview
};

const nodes = {
    HKCameraWall,//海康监视控件
    nvEleCalendar,// 日历控件
    CASignView,       //CA签章公共组件
    Root,         // 登陆中转页
    customModal,  // 弹出窗组件
    nvTag,        // 标签组件（可用来标记筛选条件）
    nselect,      // 自定义下拉列表
    dicSelect,    // 字典下拉列表
    dicTypeSelect,  //字典类型
    comRegion,    // 行政区域选择组件1
    comInstitution,    // 选择组件
    comRegion2,   // 行政区域选择组件2（级联菜单形式）
    jsonEdit,     // JSON编辑器组件
    TextJsonEdit, //文本JSON编辑器组件
    toolBar,      // 工具栏组件
    searchCom,    // 高级搜索组件
    grid,         // 数据表格组件（老：建议不再使用请使用vxeGrid替换）
    treeGrid,     // 树形表格组件（老：建议不再使用请使用vxeTreeGrid替换） 
    changeTheme,  // 换肤列表组件
    imgBase64,    // 图片上传导出base64
    uploadFile,   // 文件上传组件
    javaUploadFile,    //nplms项目用（java）
    javaUploadFileList,
    comForm,      // 表单组件
    pageTitle,    // 页面头部标题
    excelImport,  // excel上传
    logPanel,     // 日志面板
    dynamicForm,  // 动态Form，生成没有固定model的Form表单
    textEditor,   // 富文本编辑器
    dateAreaSel,  // 日期区域选择组件（APM中用到过）
    Highchart,    // highcharts图表
    echart,
    autocomplete, // 建议input
    comDetails,   // 表单详情页
    dataGrid,     // 数据Grid
    changeSubsys, //子系统切换
    vxeTreeGrid,  //vxe-table 树形表格组件
    vxeGrid,      //vxe-table 表格组件
    transfer,     //穿梭框
    listview,     //列表+列表选择组件
    // echartsGenerator, // EChart 生成器
    // echartsParse, // EChart 解析器
    FilterTable, //Table表格筛选
    leftSelect, //左侧选择
    propertyGrid, // 属性Grid
    boxBorderIcon,  //
    notification,    //消息提示组件
    flowSteps,        //流程步骤列表组件
    treeView,         //树形组件
    CASignVerify, // 签字验证
    updatePwd,    //修改密码
    loginout,     //退出登录
    userAvatar,   //用户名及头像
    applySign,    //申请签字组件
    /* 注意注意！！！请将新增的公共的组件导出于该行注释之前  */
    /* 组件导出顺序会影响互相使用 */
    LoginCom,     //登录组件（置于最后）
    MainManageCom,//大主页（置于最后），在主页导出前保证其他的子组件都已被导出，所以置于最后进行导出
    toolsPanel, // 工具面板
    MonacoEditor,
    nmis,
    box,
    layout,
    list,
    dynamicPage,
    // DrawFlow,
    addNode,
    nodeWrap,
    workflow,
    nvTemplate,
    nvRadio,
    nvCheckbox,
    nvSelect,
    nvList,
    nvListItem,
    nvSpace,
    nvNewLine,
    ImageMark,
    PicturePreview
}

const install = function (Vue, opts = {}) {
    if ((install as any).installed) return;

    Object.keys(nodes).forEach(key => {
        Vue.component(key, nodes[key]);
    });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    version: "1.0.0",
    install
};

export default API;
